@if (state.isMobile) {
  <dojo-image
    class="size-[112px] cursor-grab p-4 transition duration-300 ease-in-out md:m-3 md:hover:scale-110"
    @appearDisappear
    [src]="senseiImagePath()"
    (click)="openMCQChat()"
  />
} @else {
  <div
    cdkDrag
    [cdkDragFreeDragPosition]="fabPosition()"
    (cdkDragStarted)="onFabDragStarted()"
    (cdkDragEnded)="onFabDragEnded($event)"
  >
    <dojo-image
      class="size-20 cursor-grab !transition duration-300 ease-in-out md:m-3 md:hover:scale-110"
      @appearDisappear
      [src]="senseiImagePath()"
      cdkDragHandle
      (click)="openMCQChat()"
    />

    @if (showSuggestions()) {
      <!-- Floating suggestion buttons for MCQ questions only - hide when there are existing messages -->
      <!-- Chat suggestions orbiting around sensei -->
      <div class="floating-chat-suggestions" @appearDisappear>
        @for (suggestion of state.chatSuggestions; track suggestion.label; let i = $index) {
          <dojo-button
            [class]="'floating-suggestion-btn orb-' + (i + 1)"
            [fill]="'outline'"
            [size]="'s'"
            (click)="openMCQChat(suggestion.value)"
          >
            <dojo-icon class="mr-2" [size]="14" [icon]="suggestion.icon" [iconClass]="suggestion.color" />
            <span class="font-medium text-neutral-500 dark:text-neutral-700">{{ suggestion.label }}</span>
          </dojo-button>
        }
      </div>
    }
  </div>
}
